// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3z83p","box":"WorkspacesBox_box__qe5xi","node":"WorkspacesBox_node__BRB5q"};